module.exports = __webpack_public_path__ + "media/newstyle/images/bok2-logo-min-4eed32fb9c46099e3fb18553c838a224.png";